module.exports = __webpack_public_path__ + "img/ai3.54be09e5.png";